import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  standalone: false,
  selector: 'iwt-estatecloud-app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent {}
